import { FC } from 'react';

interface CardCaptionProps {
  /**
   * Text to render
   */
  value: string;
  /**
   * Color of the text
   */
  color?: string;
}

export const CardCaption: FC<CardCaptionProps> = ({ value, color }) => {
  return (
    <div data-testid="card-caption" style={{ transform: 'scale(0.95)', fontSize: 14, color }}>
      {value}
    </div>
  );
};
